"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1870],{

/***/ 83869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hi": function() { return /* binding */ fetchStoryToonEpisode; },
/* harmony export */   "Rh": function() { return /* binding */ fetchStoryToons; },
/* harmony export */   "hs": function() { return /* binding */ fetchStoryToon; },
/* harmony export */   "u1": function() { return /* binding */ fetchStoryToonEpisodes; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79825);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60186);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45874);
/* harmony import */ var _utils_webtoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23043);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39322);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};





var STORY_TOON_ENDPOINT = "/story-toons";
var STORY_TOON_REQUEST_TIMEOUT = 8000;
var withStoryToonTimeout = function() {
    var _ref = _asyncToGenerator(function(request) {
        var timeoutId, timeout;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    timeout = new Promise(function(_, reject) {
                        timeoutId = setTimeout(function() {
                            return reject(new Error("StoryToon request timed out"));
                        }, STORY_TOON_REQUEST_TIMEOUT);
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        Promise.race([
                            request,
                            timeout
                        ])
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                    }
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function withStoryToonTimeout(request) {
        return _ref.apply(this, arguments);
    };
}();
var normalizeList = function(data) {
    return Array.isArray(data) ? data : data.items;
};
var isNotFoundError = function(error) {
    var ref;
    return axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError(error) && ((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 404;
};
var ref;
var isUnavailableStoryToonListError = function(error) {
    var ref1;
    return axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError(error) && [
        400,
        404
    ].includes((ref = (ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) !== null && ref !== void 0 ? ref : 0);
};
var fetchStoryToons = function() {
    var _ref = _asyncToGenerator(function() {
        var data, response, error;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        withStoryToonTimeout(___WEBPACK_IMPORTED_MODULE_4__/* .api.get */ .hi.get("".concat(STORY_TOON_ENDPOINT, "/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            storyToonIds: _constants__WEBPACK_IMPORTED_MODULE_1__/* .WEBTOON_STORY_TOON_IDS.join */ .FA.join(",")
                        }))))
                    ];
                case 1:
                    response = _state.sent();
                    data = response.data;
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    if (isUnavailableStoryToonListError(error)) {
                        return [
                            2,
                            []
                        ];
                    }
                    throw error;
                case 3:
                    return [
                        2,
                        normalizeList(data)
                    ];
            }
        });
    });
    return function fetchStoryToons() {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoryToon = function() {
    var _ref = _asyncToGenerator(function(webtoonId) {
        var data, error, storyToons, storyToon;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        4
                    ]);
                    return [
                        4,
                        withStoryToonTimeout(___WEBPACK_IMPORTED_MODULE_4__/* .api.get */ .hi.get("".concat(STORY_TOON_ENDPOINT, "/").concat(webtoonId, "/")))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
                case 2:
                    error = _state.sent();
                    if (!isNotFoundError(error)) {
                        throw error;
                    }
                    return [
                        4,
                        fetchStoryToons().catch(function() {
                            return [];
                        })
                    ];
                case 3:
                    storyToons = _state.sent();
                    storyToon = storyToons.find(function(item) {
                        var ref;
                        return (0,_utils_webtoon__WEBPACK_IMPORTED_MODULE_3__/* .getStoryToonId */ .E6)(item) === webtoonId || item.storyId === webtoonId || ((ref = item.story) === null || ref === void 0 ? void 0 : ref.id) === webtoonId;
                    });
                    if (!storyToon) {
                        throw error;
                    }
                    return [
                        2,
                        storyToon
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchStoryToon(webtoonId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoryToonEpisodes = function() {
    var _ref = _asyncToGenerator(function(storyToonId) {
        var ordering, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    ordering = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "oldest";
                    return [
                        4,
                        withStoryToonTimeout(___WEBPACK_IMPORTED_MODULE_4__/* .api.get */ .hi.get("".concat(STORY_TOON_ENDPOINT, "/").concat(storyToonId, "/episodes/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            ordering: ordering,
                            page: 1,
                            perPage: _constants__WEBPACK_IMPORTED_MODULE_1__/* .WEBTOON_EPISODE_LIST_LIMIT */ .xi
                        }))))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        normalizeList(data)
                    ];
            }
        });
    });
    return function fetchStoryToonEpisodes(storyToonId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoryToonEpisode = function() {
    var _ref = _asyncToGenerator(function(storyToonId, storyToonEpisodeId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        withStoryToonTimeout(___WEBPACK_IMPORTED_MODULE_4__/* .api.get */ .hi.get("".concat(STORY_TOON_ENDPOINT, "/").concat(storyToonId, "/episodes/").concat(storyToonEpisodeId, "/")))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStoryToonEpisode(storyToonId, storyToonEpisodeId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 26382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11717);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83289);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var _stores_useThemeStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34946);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60186);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30259);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96964);
/* harmony import */ var _Push__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23516);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    max-width: ",
        "px;\n    margin: 0 auto;\n    background-color: ",
        ";\n    min-height: 100%;\n\n    color: ",
        ";\n\n    ",
        " {\n      max-width: ",
        "px;\n    }\n\n    ",
        " {\n      max-width: ",
        "px;\n    }\n\n    @media all and (min-width: ",
        "px) {\n      box-shadow: 0 0 10px ",
        "cc;\n    }\n\n    .has-sidebar & {\n      ",
        " {\n        max-width: none;\n        margin: 0;\n        box-shadow: none;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  min-height: 100%;\n\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n                @media all and (min-width: ",
        "px) {\n                  html {\n                    background-color: ",
        ";\n                  }\n                }\n              "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n                html {\n                  background-color: ",
        " !important;\n                }\n              "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var pcLayoutCSS = function(backgroundColor) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject(), _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .MAX_WIDTH */ .d, backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.var.white, theme.var.black, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .media.tablet */ .BC.tablet, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINTS.tablet */ .j$.tablet, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .media.desktop */ .BC.desktop, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINTS.desktop */ .j$.desktop, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINTS.desktop */ .j$.desktop + 1, theme.var.gray200, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .media.tablet */ .BC.tablet);
    };
};
var mobileLayoutCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject1(), theme.var.black);
};
var Layout = function(param) {
    var className = param.className, theme = param.theme, backgroundColor = param.backgroundColor, children = param.children, isSSR = param.isSSR, isPush = param.isPush;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_4__/* .useGlobalContext */ .bN)().platform;
    var setTheme = (0,_stores_useThemeStore__WEBPACK_IMPORTED_MODULE_2__/* .useThemeStore */ .f)().setTheme;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isSSR) {
            return;
        }
        // theme prop이 명시적으로 전달된 경우에만 override
        if (theme) {
            setTheme(theme);
        } else {
            // localStorage에 저장된 테마가 없을 때만 __darkMode__ 사용
            var stored = localStorage.getItem("theme");
            if (!stored) {
                setTheme(window.__darkMode__ ? "dark" : "light");
            }
        }
    }, [
        theme,
        isSSR
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: className,
        suppressHydrationWarning: true,
        css: platform === _constants__WEBPACK_IMPORTED_MODULE_3__/* .Platform.web */ .t4.web ? pcLayoutCSS(backgroundColor) : mobileLayoutCSS,
        children: [
            backgroundColor && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("meta", {
                    name: "theme-color",
                    content: backgroundColor
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_7__.Global, {
                styles: function(theme) {
                    return platform === _constants__WEBPACK_IMPORTED_MODULE_3__/* .Platform.web */ .t4.web ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject2(), _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINTS.desktop */ .j$.desktop + 1, theme.var.gray100) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject3(), backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.var.white);
                }
            }),
            children,
            isPush && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_Push__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                size: _Push__WEBPACK_IMPORTED_MODULE_6__/* .PushSize.bottomTab */ .z.bottomTab,
                bottom: true
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 23043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cn": function() { return /* binding */ getStoryToonEpisodeThumbnail; },
/* harmony export */   "E6": function() { return /* binding */ getStoryToonId; },
/* harmony export */   "FY": function() { return /* binding */ getStoryToonEpisodeNumber; },
/* harmony export */   "KK": function() { return /* binding */ getStoryToonAuthorName; },
/* harmony export */   "KW": function() { return /* binding */ getStoryToonTitle; },
/* harmony export */   "P": function() { return /* binding */ getWebtoonStoryMeta; },
/* harmony export */   "Pi": function() { return /* binding */ getWebtoonEpisodePath; },
/* harmony export */   "fP": function() { return /* binding */ getStoryToonEpisodeImages; },
/* harmony export */   "hC": function() { return /* binding */ getStoryToonEpisodeByNumber; },
/* harmony export */   "tm": function() { return /* binding */ getStoryToonCoverImage; },
/* harmony export */   "v$": function() { return /* binding */ getStoryToonSubtitle; },
/* harmony export */   "wk": function() { return /* binding */ parseWebtoonRouteNumber; },
/* harmony export */   "yA": function() { return /* binding */ getWebtoonStoryPath; }
/* harmony export */ });
/* unused harmony export getWebtoonEpisodeByNumber */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60186);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var getWebtoonStoryMeta = function(storyId) {
    if (!storyId) {
        return undefined;
    }
    return _constants__WEBPACK_IMPORTED_MODULE_0__/* .WEBTOON_STORIES.find */ .lV.find(function(story) {
        return story.id === storyId;
    });
};
var parseWebtoonRouteNumber = function(value) {
    var rawValue = Array.isArray(value) ? value[0] : value;
    var parsedValue = Number(rawValue);
    return Number.isSafeInteger(parsedValue) && parsedValue > 0 ? parsedValue : undefined;
};
var ref, ref1;
var getStoryToonId = function(storyToon) {
    return (ref1 = (ref = storyToon === null || storyToon === void 0 ? void 0 : storyToon.webtoonId) !== null && ref !== void 0 ? ref : storyToon === null || storyToon === void 0 ? void 0 : storyToon.storyToonId) !== null && ref1 !== void 0 ? ref1 : storyToon === null || storyToon === void 0 ? void 0 : storyToon.id;
};
var getWebtoonStoryPath = function(storyId) {
    return "/webtoon/".concat(storyId);
};
var getWebtoonEpisodePath = function(storyId, episodeNumber) {
    return "/webtoon/".concat(storyId, "/").concat(episodeNumber);
};
var getWebtoonEpisodeByNumber = function(episodes, episodeNumber) {
    if (!episodeNumber) {
        return undefined;
    }
    return episodes[episodeNumber - 1];
};
var ref2, ref3, ref4;
var getStoryToonTitle = function(storyToon, webtoonMeta) {
    var ref;
    return (ref4 = (ref3 = (ref2 = storyToon === null || storyToon === void 0 ? void 0 : storyToon.title) !== null && ref2 !== void 0 ? ref2 : storyToon === null || storyToon === void 0 ? void 0 : (ref = storyToon.story) === null || ref === void 0 ? void 0 : ref.title) !== null && ref3 !== void 0 ? ref3 : webtoonMeta === null || webtoonMeta === void 0 ? void 0 : webtoonMeta.title) !== null && ref4 !== void 0 ? ref4 : "";
};
var ref5, ref6, ref7, ref8;
var getStoryToonSubtitle = function(storyToon, webtoonMeta) {
    var ref;
    return (ref8 = (ref7 = (ref6 = (ref5 = storyToon === null || storyToon === void 0 ? void 0 : storyToon.subtitle) !== null && ref5 !== void 0 ? ref5 : storyToon === null || storyToon === void 0 ? void 0 : storyToon.summary) !== null && ref6 !== void 0 ? ref6 : storyToon === null || storyToon === void 0 ? void 0 : (ref = storyToon.story) === null || ref === void 0 ? void 0 : ref.summary) !== null && ref7 !== void 0 ? ref7 : webtoonMeta === null || webtoonMeta === void 0 ? void 0 : webtoonMeta.subtitle) !== null && ref8 !== void 0 ? ref8 : "";
};
var ref9;
var getStoryToonAuthorName = function(storyToon) {
    var ref, ref1;
    return (ref9 = storyToon === null || storyToon === void 0 ? void 0 : (ref = storyToon.story) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.nickname) !== null && ref9 !== void 0 ? ref9 : "";
};
var ref10, ref11, ref12, ref13;
var getStoryToonCoverImage = function(storyToon) {
    var ref;
    return (ref13 = (ref12 = (ref11 = (ref10 = storyToon === null || storyToon === void 0 ? void 0 : storyToon.thumbnailImage) !== null && ref10 !== void 0 ? ref10 : storyToon === null || storyToon === void 0 ? void 0 : storyToon.coverImage) !== null && ref11 !== void 0 ? ref11 : storyToon === null || storyToon === void 0 ? void 0 : storyToon.mainImage) !== null && ref12 !== void 0 ? ref12 : storyToon === null || storyToon === void 0 ? void 0 : storyToon.image) !== null && ref13 !== void 0 ? ref13 : storyToon === null || storyToon === void 0 ? void 0 : (ref = storyToon.story) === null || ref === void 0 ? void 0 : ref.coverImage;
};
var _episodeNumber, ref14, ref15;
var getStoryToonEpisodeNumber = function(episode, index) {
    return (ref15 = (ref14 = (_episodeNumber = episode.episodeNumber) !== null && _episodeNumber !== void 0 ? _episodeNumber : episode.number) !== null && ref14 !== void 0 ? ref14 : episode.order) !== null && ref15 !== void 0 ? ref15 : index + 1;
};
var getStoryToonEpisodeByNumber = function(episodes, episodeNumber) {
    if (!episodeNumber) {
        return undefined;
    }
    var ref;
    return (ref = episodes.find(function(episode, index) {
        return getStoryToonEpisodeNumber(episode, index) === episodeNumber;
    })) !== null && ref !== void 0 ? ref : episodes[episodeNumber - 1];
};
var getImageFromSlot = function(slot) {
    if (!slot) {
        return undefined;
    }
    if ("attachment" in slot) {
        return slot;
    }
    var _image;
    return (_image = slot.image) !== null && _image !== void 0 ? _image : slot.file;
};
var isStoryToonImage = function(image) {
    var ref;
    return !!(image === null || image === void 0 ? void 0 : (ref = image.attachment) === null || ref === void 0 ? void 0 : ref.url);
};
var getStoryToonEpisodeImages = function(episode) {
    var ref;
    if (!episode) {
        return [];
    }
    var ref1, _images, _episodeImages, _toonImages, _imageFiles, _contentImages, _files, _cuts, ref2, _pages, ref3;
    return _toConsumableArray((ref1 = (ref = episode.content) === null || ref === void 0 ? void 0 : ref.images) !== null && ref1 !== void 0 ? ref1 : []).concat(_toConsumableArray((_images = episode.images) !== null && _images !== void 0 ? _images : []), _toConsumableArray((_episodeImages = episode.episodeImages) !== null && _episodeImages !== void 0 ? _episodeImages : []), _toConsumableArray((_toonImages = episode.toonImages) !== null && _toonImages !== void 0 ? _toonImages : []), _toConsumableArray((_imageFiles = episode.imageFiles) !== null && _imageFiles !== void 0 ? _imageFiles : []), _toConsumableArray((_contentImages = episode.contentImages) !== null && _contentImages !== void 0 ? _contentImages : []), _toConsumableArray((_files = episode.files) !== null && _files !== void 0 ? _files : []), _toConsumableArray((ref2 = ((_cuts = episode.cuts) !== null && _cuts !== void 0 ? _cuts : []).map(getImageFromSlot)) !== null && ref2 !== void 0 ? ref2 : []), _toConsumableArray((ref3 = ((_pages = episode.pages) !== null && _pages !== void 0 ? _pages : []).map(getImageFromSlot)) !== null && ref3 !== void 0 ? ref3 : []), [
        episode.contentImage,
        episode.imageFile,
        episode.image, 
    ]).filter(isStoryToonImage);
};
var ref16;
var getStoryToonEpisodeThumbnail = function(episode) {
    return (ref16 = episode === null || episode === void 0 ? void 0 : episode.thumbnailImage) !== null && ref16 !== void 0 ? ref16 : getStoryToonEpisodeImages(episode)[0];
};


/***/ })

}]);